// GSAP-Parallax-Effekt
document.addEventListener('DOMContentLoaded', function () {
  const parallaxImages = document.querySelectorAll('.parallax-img');

  gsap.registerPlugin(ScrollTrigger);

  function initParallax() {
    parallaxImages.forEach(function (image) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: image,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });

      const speed = parseFloat(image.getAttribute('data-speed'));
      tl.to(image, { y: speed * 100 + '%' });
    });
  }

  initParallax();
});

document.addEventListener('DOMContentLoaded', function () {
  const parallaxImages = document.querySelectorAll('.home-parallax-img');

  gsap.registerPlugin(ScrollTrigger);

  function initParallax() {
    parallaxImages.forEach(function (image) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: image,
          start: 'top',
          end: 'bottom',
          scrub: true
        }
      });

      const speed = parseFloat(image.getAttribute('data-speed'));
      tl.to(image, { y: speed * 100 + '%' });
    });
  }

  initParallax();
});